// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3tCvj","footer":"ModalCreateQualiphyProcedure_footer__19ylz","additionData":"ModalCreateQualiphyProcedure_additionData__18xHF"};